var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.computeClass},[_c('SchoolWorkingSectionExportLegend',{staticClass:"mr-4"}),_c('SchoolAwaySectionExportLegend',{staticClass:"mr-4",attrs:{"aways":_vm.aways}}),_c('SchoolLeaveSectionExportLegend',{staticClass:"mr-4",attrs:{"leaves":_vm.leaves}}),_c('SchoolTotalSectionExportLegend')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }